import React from 'react';

import cn from 'classnames';

import propertyLogo from 'assets/images/properties/property-logo.svg';
import { ReturnComponentType } from 'common';
import './PropertyTitleSection.scss';
import { useAppSelector } from 'hooks';
import { selectPropertiesSearch } from 'state';
import { HighlightedString } from 'ui-kit';

type PropertyTitleSectionType = {
  address: string;
  isModal: boolean;
  className?: string;
};

export const PropertyTitleSection = ({
  address,
  isModal,
  className,
}: PropertyTitleSectionType): ReturnComponentType => {
  const search = useAppSelector(selectPropertiesSearch);

  return (
    <section className={cn('PropertyTitleSection', className)}>
      <img src={propertyLogo} alt="property-logo" className="PropertyTitleSection_Logo" />
      <h4 className="PropertyTitleSection_Title">
        {isModal ? address : <HighlightedString oldString={address} search={search} />}
      </h4>
    </section>
  );
};
